import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { CreationForm, CreationFormTemplate } from "../../components/form/CreationForm";
import { ChangePassFormTemplate, MyAccountFormTemplate } from "../../data-parsing/myAccount/FormTemplate";
import { Admin } from "../../data-parsing/admins/Admin";
import { useMyself } from "../../hooks";
import { User } from "../../data-parsing/users/User";
import { ResponseStatus, StatusContextApi } from "../../context/status";
import { useContext, useEffect, useState } from "react";
import { getKeyByValue } from "../../data-parsing/parseUtils";
import { PrimeReactProvider } from "primereact/api";
import { TestUploadImage } from "../_alreylz/DevUtils";

import { Calendar } from 'primereact/calendar';
import API from "../../api/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';
import { useNavigate } from "react-router-dom";

import { useGetMyselfDoctor } from ".";
import { TestDragger2, generateDateRange, generateThirtyMinuteSlots, isSameDay } from "./WorkingHoursManagement/TestDragger2";
import { WeekDaySelector2 } from "./WorkingHoursManagement/WeekDaySelector2";
import { ContextualTooltip } from "./WorkingHoursManagement/ContextualTooltip";

const spanishLocale = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ],
    monthNamesShort: [
        "ene", "feb", "mar", "abr", "may", "jun",
        "jul", "ago", "sep", "oct", "nov", "dic"
    ],
    today: "Hoy",
    clear: "Limpiar",
    dateFormat: "dd/mm/yy"
};


addLocale('es', spanishLocale);



const dayNamesMin = ["L", "M", "X", "J", "V", "S", "D"]













// My account debería ser diferente para cada rols
export function MiDisponibilidad({ debug = false, useVersion = 1 }) {

    // To add UI messages regarding the state of requests
    const { addMessage } = useContext(StatusContextApi);

    const myUser = sessionStorage.getItem("user");

    const isDoctor = sessionStorage.getItem("doctor") === "true" || false;
    const navigate = useNavigate()



    //Gets the info of a doctor
    const { doctorInfo, isFetching, gotError, updateDoctorInfo, updatePassword } = useGetMyselfDoctor(sessionStorage.getItem("userid"))




    const [formData, setFormData] = useState(
        {
            doctorActive: "yes", // In the back 1 means active
            date: null
        })


    //This waits to initialize with values from the server
    useEffect(() => {
        const convertBackendFieldsOfInterest = (rawDoctorInfo) => {
            return {
                //   3 valores: '1'-- > Activo, '0'-- > Inactivo, '-1'
                doctorActive:
                    rawDoctorInfo.activeDr === 1 ?
                        "yes" :
                        rawDoctorInfo.activeDr === 0 ?
                            "no" :
                            "deactivate",
                date: doctorInfo.activeDate ?? null
            }
        }


        if (doctorInfo) {
            setFormData(
                convertBackendFieldsOfInterest(doctorInfo)
            )
        }
    }, [doctorInfo]);



    const handleChangeDoctorInActive = (name, value) => {
        setFormData((prev) => {
            return { ...prev, [name]: value }
        })
    }



    function validateFields(formData) {
        if (formData.get(getKeyByValue(User, User.password)) !== formData.get(getKeyByValue(User, User.passwordVerification))) {
            addMessage(ResponseStatus.ERROR, 5000, "Los valores de contraseña introducidos no coinciden");
            return false;
        }
        return true;
    }





    const [stateV2, setStateV2] = useState({

        mouseClickData: null,
        chosenDateData: null
    });



    //De esta manera puedo guardar los días de no disponibilidad y mostrarlos en el calendario
    const sampleDiasVacaciones = generateDateRange(new Date("2025-07-10"), new Date("2025-07-20"))



    const [dateTooltipVisible, setDateTooltipVisible] = useState(false)

    const handleShowDayModal = (show) => {

        setDateTooltipVisible(show)
    }
    // show the modal when the day changes
    // keep track of the slots selected or unselected.
    // then on Confirm, or on cancel



    //Esto configura cómo se ven las cosas en el calendario para cada día.

    const dateTemplate = (dateMeta) => {
        const { day, month, year, today, otherMonth } = dateMeta;


        const fullDate = new Date(year, month, day);


        const isHoliday = sampleDiasVacaciones.some((v) => {
            return isSameDay(v, fullDate)
        })


        const style = {
            backgroundColor: isHoliday ? "orange" : undefined,
            padding: "0.2em",

            borderRadius: "50%",
            fontWeight: today ? 'bold' : undefined,
            opacity: otherMonth ? 0.4 : 1,
        };



        return (
            <div style={style}

                selectable={false}
                onClick={(ev) => {
                    window.alert(`Selected day ${JSON.stringify(dateMeta)}`)
                    handleShowDayModal(true)
                    setStateV2((prev) => {
                        return {
                            ...prev,
                            ["mouseClickData"]: ev,
                            ["chosenDateData"]: dateMeta
                        }
                    })
                }
                }>
                {day}
            </div >
        );
    }




    return <LeftSideMenu active="nutritionist/miDisponibilidad">

        <div id="wrapper">

            <div className="container">
                {debug &&
                    <>
                        <h3> Debug</h3>
                        <p>{JSON.stringify(doctorInfo)}</p>
                    </>
                }

                {!isDoctor && useVersion == 1 ? <Error message="no autorizado"></Error> :
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="card-box card-tabs m-t-20">
                                <div className="row">
                                    <h4 className="header-title m-r-10 m-t-0 pull-right">MI DISPONIBILIDAD</h4>
                                </div>


                                {isDoctor &&

                                    isFetching ? <span> Cargando</span> : gotError ? <span> Error cargando  datos desde  server</span> :
                                    (<>

                                        <div style={{ display: "grid" }}>
                                            <div className="container-group col-sm-12">
                                                <h3 className="m-t-10 m-b-0"> Gestión disponibilidad del nutricionista{/*v1*/}</h3>
                                                <hr className="m-t-10" />
                                            </div>

                                            <div style={{ display: "grid", gap: "1em", paddingLeft: "2em" }} >
                                                <label style={{ display: "flex", gap: "0.5em" }} >
                                                    <input type="radio"
                                                        name="doctorActive"
                                                        value="yes"
                                                        checked={formData.doctorActive === "yes"}
                                                        onChange={(e) => handleChangeDoctorInActive("doctorActive", "yes")} />
                                                    Yes
                                                </label>

                                                <label style={{ display: "flex", gap: "0.5em" }}>
                                                    <input type="radio" name="doctorActive" value="no"

                                                        checked={formData.doctorActive === "no"}
                                                        onChange={(e) => handleChangeDoctorInActive("doctorActive", "no")}

                                                    />
                                                    No
                                                </label>


                                                <div style={{ display: "flex", gap: "2em", alignItems: "center" }}>
                                                    <label style={{ display: "flex", gap: "0.5em" }}>
                                                        <input type="radio" name="doctorActive" value="deactivate"
                                                            checked={formData.doctorActive === "deactivate"}
                                                            onChange={(e) => handleChangeDoctorInActive("doctorActive", "deactivate")}

                                                        />
                                                        Desactivar a partir de una fecha
                                                    </label>

                                                    {formData.doctorActive === "deactivate" &&
                                                        <PrimeReactProvider value={{ unstyled: false }}>
                                                            <Calendar
                                                                style={{ placeSelf: "center" }}
                                                                value={formData.date ? new Date(formData.date) : new Date()}
                                                                onChange={(e) => handleChangeDoctorInActive("date", e.value)}
                                                                locale="es"
                                                            />
                                                        </PrimeReactProvider>

                                                    }
                                                </div>
                                                <div class="col-sm-12">
                                                    <button className="btn btn-rounded btn-purple m-b-20 " onClick={async () => {
                                                        const convertFrontendFieldsOfInterest = (formData) => {
                                                            return {
                                                                activeDr:
                                                                    formData.doctorActive === "yes" ? 1 :
                                                                        formData.doctorActive === "no" ? 0 :
                                                                            -1,

                                                                activeDate: formData.date ?? null
                                                            };
                                                        };

                                                        addMessage(ResponseStatus.PENDING, 1000, "Actualizando en el servidor... ");

                                                        const updatedDoctor = {
                                                            ...doctorInfo,
                                                            ...convertFrontendFieldsOfInterest(formData)
                                                        }

                                                        const result = await updateDoctorInfo(updatedDoctor)


                                                        addMessage(ResponseStatus.RESOLVED, 2000, "Actualizado  ");

                                                        // window.alert(` IDK what happened ${JSON.stringify(result)}`)
                                                    }}> Actualizar info</button>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                    )}



                                {/* V2 */}
                                {useVersion == 2 && <div className="row">
                                    <div className="container-group col-sm-12">
                                        <h3 className="m-t-10 m-b-0"> Gestión disponibilidad (v2)</h3>
                                        <hr className="m-t-10" />
                                    </div>





                                    <div className="row">
                                        <div className="container-group col-sm-12">

                                            <h4> Selecciona tu jornada laboral habitual</h4>
                                            <label> Hora de inicio:  </label><input type="time" name="usual_start_time" />
                                            <label> Hora de fin: </label><input type="time" name="usual_end_time" />
                                        </div>
                                    </div>



                                    <WeekDaySelector2 ></WeekDaySelector2>

                                    <PrimeReactProvider value={{ unstyled: false }}>
                                        <div >

                                            <Calendar
                                                inline
                                                // value={stateV2}
                                                onChange={(e) => {
                                                    e.preventDefault()
                                                    // handleShowDayModal(true)
                                                }}
                                                dateTemplate={dateTemplate}
                                                locale="es"
                                            />

                                            <ContextualTooltip
                                                visible={dateTooltipVisible}
                                                tooltipData={
                                                    {
                                                        ev:
                                                            stateV2["mouseClickData"],
                                                        customData:
                                                            stateV2["chosenDateData"]
                                                    }}
                                            >


                                                <TestDragger2 data={generateThirtyMinuteSlots()}></TestDragger2>
                                                <h4> Tooltip para selección de horarios disponibles cada día</h4>

                                            </ContextualTooltip>

                                        </div>
                                    </PrimeReactProvider>
                                    {/* <Calendar id="minmax" value={date} onChange={(e) => setDate(e.value)} minDate={minDate} maxDate={maxDate} readOnlyInput /> */}



                                    {/* <PrimeReactProvider value={{ unstyled: false }}>
                                    <Calendar

                                        style={{ placeSelf: "center" }}
                                        value={formData.date ? new Date(formData.date) : new Date()}
                                        onChange={(e) => handleChangeDoctorInActive("date", e.value)}
                                        locale="es"
                                    />
                                </PrimeReactProvider> */}


                                    {/* <div className="row" >


                                        <TestDragger2 data={generateThirtyMinuteSlots()}></TestDragger2>

                                    </div> */}







                                </div>

                                }
                            </div>
                        </div>

                    </div>}


            </div>

        </div >
    </LeftSideMenu >
}












export function Error(message) {


    return (<h1>Ocurrió un error:  {message}</h1>)
}


